import GoToActionCreator from "@/helpers/push/creators/GoToActionCreator";
import DefaultActionCreator from "@/helpers/push/creators/DefaultActionCreator";
import OpenCalendarActionCreator from "@/helpers/push/creators/OpenCalendarActionCreator";
import ViewAppointmentActionCreator from "@/helpers/push/creators/ViewAppointmentActionCreator";
import OpenChatActionCreator from "@/helpers/push/creators/OpenChatActionCreator";
const actions = {
    GoTo: GoToActionCreator,
    ViewCalendar: OpenCalendarActionCreator,
    OpenChat: OpenChatActionCreator,
    ViewAppointment: ViewAppointmentActionCreator,
};
export default class PushNotificationActionHandler {
    actionString;
    action;
    constructor(action, args) {
        this.actionString = `${action[0].toUpperCase()}${action.slice(1)}`;
        let creator = new DefaultActionCreator();
        if (Object.keys(actions).includes(this.actionString)) {
            creator = new actions[this.actionString](args);
        }
        this.action = creator.create();
    }
    run() {
        this.action.run();
    }
}
